(function () {
  'use strict';

  var DIRHAM = '<svg class="dirham" viewBox="0 0 24 24" role="img" aria-label="AED" focusable="false"><path d="M7 3.5h4.5a8.5 8.5 0 0 1 0 17H7z" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/><path d="M2.5 10h17.5M2.5 14h17.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts[1] === '00' ? whole : whole + '.' + parts[1];
    return '<span class="price-amount">' + DIRHAM + amount + '</span>';
  }

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { return null; }
    return null;
  }

  // Header border on scroll
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.getElementById('MobileNav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Scroll reveal
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Sort select on collection page
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  // Product gallery (images and videos)
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    function show(mediaId) {
      gallery.querySelectorAll('[data-media-slide]').forEach(function (slide) {
        var active = slide.getAttribute('data-media-slide') === String(mediaId);
        slide.classList.toggle('is-active', active);
        slide.querySelectorAll('video').forEach(function (v) {
          if (active) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
        });
      });
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        var active = t.getAttribute('data-media-id') === String(mediaId);
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
    gallery._show = show;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(thumb.getAttribute('data-media-id')); });
    });
  });

  // Card message counter
  document.querySelectorAll('[data-char-count]').forEach(function (area) {
    var left = area.parentNode.querySelector('[data-char-left]');
    var max = parseInt(area.getAttribute('maxlength'), 10) || 250;
    var update = function () { if (left) left.textContent = max - area.value.length; };
    area.addEventListener('input', update);
    update();
  });

  // Product form: variants + add-ons
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var jsonEl = form.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var moneyFormat = form.getAttribute('data-money-format');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var button = form.querySelector('[data-add-button]');
    var buttonText = form.querySelector('[data-add-text]');
    var errorEl = form.querySelector('[data-form-error]');
    var gallery = document.querySelector('[data-gallery]');

    function selectedOptions() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option-group]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function updateVariant() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!variant) {
        if (button) button.disabled = true;
        if (buttonText) buttonText.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        var html = formatMoney(variant.price, moneyFormat);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += ' <s>' + formatMoney(variant.compare_at_price, moneyFormat) + '</s>';
        }
        priceEl.innerHTML = html;
      }
      if (button) button.disabled = !variant.available;
      if (buttonText) buttonText.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (variant.featured_media && gallery && gallery._show) gallery._show(variant.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.querySelectorAll('[data-option-group] input').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    // Keep add-on checkbox value in sync with its option select
    form.querySelectorAll('.addon').forEach(function (addon) {
      var check = addon.querySelector('[data-addon-check]');
      var select = addon.querySelector('[data-addon-variant]');
      if (check && select) {
        select.addEventListener('change', function () { check.value = select.value; check.checked = true; });
      }
    });

    form.addEventListener('submit', function (event) {
      if (!window.fetch) return;
      event.preventDefault();
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

      var properties = {};
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name || el.name.indexOf('properties[') !== 0) return;
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
        var key = el.name.slice(11, -1);
        if (el.value !== '') properties[key] = el.value;
      });

      var items = [{ id: Number(idInput.value), quantity: 1, properties: properties }];
      form.querySelectorAll('[data-addon-check]:checked').forEach(function (check) {
        items.push({ id: Number(check.value), quantity: 1, properties: { '_For': product.title } });
      });

      if (button) { button.disabled = true; }
      if (buttonText) buttonText.textContent = 'Adding…';

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error(result.data.description || result.data.message || 'Something went wrong.');
          window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          if (button) button.disabled = false;
          if (buttonText) buttonText.textContent = 'Add to bag';
        });
    });
  });

  // Cart quantity buttons
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-step'), 10);
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        if (input.form) input.form.submit();
      });
    });
  });

  // Discount code field in the bag
  document.querySelectorAll('[data-discount-form]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var btn = wrap.querySelector('button');
    function apply() {
      var code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    }
    if (btn) btn.addEventListener('click', apply);
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
  });

  // Copy-to-clipboard for discount codes
  document.querySelectorAll('[data-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var text = btn.getAttribute('data-copy');
      var label = btn.querySelector('[data-copy-label]') || btn;
      var done = function () {
        var old = label.textContent;
        label.textContent = 'Copied';
        setTimeout(function () { label.textContent = old; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(function () {});
      }
    });
  });

  // Pop-up: opens on the visitor's first scroll (or after the fallback delay if they don't scroll)
  document.querySelectorAll('[data-popup]').forEach(function (popup) {
    var key = 'yarime-popup-' + popup.getAttribute('data-popup-id');
    var delay = parseInt(popup.getAttribute('data-delay'), 10) || 0;
    var days = parseInt(popup.getAttribute('data-days'), 10);
    var designMode = popup.hasAttribute('data-design-mode');
    var last = parseInt(store(key) || '0', 10);
    var wait = isNaN(days) ? 7 : days;
    var justSignedUp = !!popup.querySelector('.form-success');
    if (!designMode && !justSignedUp && last && (Date.now() - last) < wait * 86400000) return;
    var lastFocus = null;

    function close() {
      popup.hidden = true;
      document.documentElement.classList.remove('popup-open');
      store(key, String(Date.now()));
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function open() {
      lastFocus = document.activeElement;
      popup.hidden = false;
      document.documentElement.classList.add('popup-open');
      var first = popup.querySelector('[data-popup-close]');
      if (first) first.focus();
    }
    popup.querySelectorAll('[data-popup-close]').forEach(function (el) { el.addEventListener('click', close); });
    popup.addEventListener('click', function (e) { if (e.target === popup) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !popup.hidden) close(); });
    if (justSignedUp || designMode) { open(); return; }
    var opened = false;
    var fallback = null;
    function trigger() {
      if (opened) return;
      opened = true;
      window.removeEventListener('scroll', onFirstScroll);
      if (fallback) clearTimeout(fallback);
      open();
    }
    function onFirstScroll() { if (window.scrollY > 80) trigger(); }
    window.addEventListener('scroll', onFirstScroll, { passive: true });
    fallback = setTimeout(trigger, (delay || 8) * 1000);
  });

  // Delivery date: no past dates
  document.querySelectorAll('input[type="date"][data-min-today]').forEach(function (el) {
    var d = new Date();
    el.min = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
  });
})();
